// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2an9b","label":"LabeledBox_label__2bAsK"};